import { render, staticRenderFns } from "./settoriAttivita.vue?vue&type=template&id=5fa84eee&scoped=true&"
import script from "./settoriAttivita.vue?vue&type=script&lang=js&"
export * from "./settoriAttivita.vue?vue&type=script&lang=js&"
import style0 from "./settoriAttivita.vue?vue&type=style&index=0&id=5fa84eee&scoped=true&lang=css&"
import style1 from "./settoriAttivita.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa84eee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VImg,VRow,VTextField})
